<template>
  <div class="whole">
    <HeadBar></HeadBar>
    <div class="main-content">
      <div class="flex spaceBetween">
        <!-- 课程信息 -->
        <div class="courseInformation">
          <div class="flex align">
            <div class="course-titleBlock"></div>
            <div class="course-titleTxt">课程信息</div>
          </div>
          <div class="courseInformation-box flex">
            <img class="courseClassificationData-cover" :src="courseClassificationData.pic" alt="" />
            <div class="courseClassificationData-information flex column">
              <div class="premiumCourses-name">{{ courseClassificationData.name }}</div>
              <div class="premiumCourses-message flex align">
                <div class="premiumCourses-founder">{{ courseClassificationData.main_person }}</div>
                <div class="premiumCourses-line"></div>
                <div class="premiumCourses-system">{{ courseClassificationData.department }}</div>
              </div>
              <div class="flex spaceBetween">
                <div class="premiumCourses-teachingRecords">授课记录：{{ courseClassificationData.num_publish }}次</div>
              </div>
              <div class="premiumCourses-divider"></div>
              <div class="premiumCourses-affiliatedPlatform">所属平台：{{ courseClassificationData.platform }}</div>
              <div @click="modifyingInformation" class="modifyingInformation pointer">点击修改信息</div>
            </div>
          </div>
        </div>
        <!-- 基础数据 -->
        <div class="courseInformation">
          <div class="flex align">
            <div class="course-titleBlock"></div>
            <div class="course-titleTxt">基础数据</div>
          </div>
          <div class="basicData-contentBox flex spaceBetween">
            <!-- 授课教师 -->
            <div class="basicData-content flex column align spaceBetween">
              <div class="basicData-txt">授课教师</div>
              <div class="basicData-num">{{ dataList.teacher_num }}</div>
            </div>
            <!-- 上课班级 -->
            <div class="basicData-content flex column align spaceBetween">
              <div class="basicData-txt">上课班级</div>
              <div class="basicData-num">{{ dataList.class_num }}</div>
            </div>
            <!-- 上课人数 -->
            <div class="basicData-content flex column align spaceBetween">
              <div class="basicData-txt">上课人数</div>
              <div class="basicData-num">{{ dataList.student_num }}</div>
            </div>
          </div>
        </div>
      </div>
      <div class="flex spaceBetween" style="margin-top: 10px">
        <div class="courseInformation">
          <div class="flex align spaceBetween">
            <div class="flex align">
              <div class="course-titleBlock"></div>
              <div class="course-titleTxt">授课数据</div>
            </div>
            <el-date-picker v-model="dateValue" :clearable="false" format="yyyy-MM-dd" value-format="yyyy-MM-dd"
              type="daterange" @change="selectDate" unlink-panels range-separator="至" start-placeholder="开始日期"
              end-placeholder="结束日期"> </el-date-picker>
          </div>
          <div class="teachingData-contentBox flex spaceBetween">
            <!-- 教师上课次数 -->
            <div class="teachingData-content flex column align spaceBetween">
              <div class="basicData-txt">教师上课次数</div>
              <div class="basicData-num">{{ teachingData.lesson_num }}</div>
            </div>
            <!-- 资源上传次数 -->
            <div class="teachingData-content flex column align spaceBetween">
              <div class="basicData-txt">资源上传次数</div>
              <div class="basicData-num">{{ teachingData.assets_num }}</div>
            </div>
            <!-- 习题上传次数 -->
            <div class="teachingData-content flex column align spaceBetween">
              <div class="basicData-txt">习题上传次数</div>
              <div class="basicData-num">{{ teachingData.exam_item_num }}</div>
            </div>
          </div>
          <div class="teachingData-contentBox1 flex spaceBetween">
            <!-- 教师发布次数 -->
            <div class="teachingData-content flex column align spaceBetween">
              <div class="basicData-txt">教师发布次数</div>
              <div class="basicData-num">{{ teachingData.publish_num }}</div>
            </div>
            <!-- 资源发布数量 -->
            <div class="teachingData-content flex column align spaceBetween">
              <div class="basicData-txt">资源发布数量</div>
              <div class="basicData-num">{{ teachingData.publish_assets_num }}</div>
            </div>
            <!-- 学生学习次数 -->
            <div class="teachingData-content flex column align spaceBetween">
              <div class="basicData-txt">学生学习次数</div>
              <div class="basicData-num">{{ teachingData.lesson_user_num }}</div>
            </div>
          </div>
        </div>
        <div class="courseInformation">
          <div class="flex align spaceBetween">
            <div class="flex align">
              <div class="course-titleBlock"></div>
              <div class="course-titleTxt">与往年数据对比</div>
            </div>
          </div>
          <div class="barChart-box">
            <barChart :preData="preData"></barChart>
          </div>
        </div>
      </div>
      <div class="flex justify">
        <div class="btnBox flex spaceBetween">
          <div @click="btnConfirm" class="btnPublicCss flex align justify pointer">确定</div>
          <div @click="btnReturn" class="btnPublicCss flex align justify pointer">返回</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { HeadBar } from "./layout/components";
// 组件
import barChart from "@/components/echarts_pie/barChart.vue";
// 接口
import { basicDataOfCourseClassification, statisticalDataOfCourseClassification } from "@/api";
export default {
  data() {
    return {
      courseClassificationData: [], // 分类数据
      dataList: [], // 数据列表
      dateValue: [], // 时间
      preData: [], // 柱状图数据
      teachingData: [], // 授课数据
    };
  },
  components: {
    HeadBar,
    barChart,
  },
  created() {
    console.log("分类数据", this.$route.params.data);
    this.courseClassificationData = this.$route.params.data; // 获取分类数据
    // 调用课程分类基础统计数接口
    let params = { category_id: this.$route.params.data?.id };
    basicDataOfCourseClassification(params).then((res) => {
      if (res.data.code == 0) {
        this.dataList = res.data.datas; // 获取数据列表
        let publicData = res.data.datas;
        this.preData = [
          { product: "教师上课次数", 往年: publicData.lastyear_lesson_num, 今年: publicData.thisyear_lesson_num },
          { product: "资源上传次数", 往年: publicData.lastyear_assets_num, 今年: publicData.thisyear_assets_num },
          { product: "习题上传次数", 往年: publicData.lastyear_exam_item_num, 今年: publicData.thisyear_exam_item_num },
          { product: "教师发布次数", 往年: publicData.lastyear_publish_num, 今年: publicData.thisyear_publish_num },
          { product: "资源发布数量", 往年: publicData.lastyear_publish_assets_num, 今年: publicData.thisyear_publish_assets_num },
          { product: "学生学习次数", 往年: publicData.lastyear_lesson_user_num, 今年: publicData.thisyear_lesson_user_num },
        ];
      }
    });
    const result = this.getRecentSevenDays();
    console.log(result.start); // 输出：最近七天的开始时间，格式为 YYYY-MM-DD HH:mm:ss
    console.log(result.end); // 输出：最近七天的结束时间，格式为 YYYY-MM-DD HH:mm:ss
    let str1 = result.start.split(" ")[0];
    let str2 = result.end.split(" ")[0];
    this.dateValue[0] = str1; // 获取默认时间
    this.dateValue[1] = str2;
    // 调用课程次数统计数据接口
    let params1 = { category_id: this.$route.params.data?.id, begin: result.start, end: result.end };
    statisticalDataOfCourseClassification(params1).then((res) => {
      if (res.data.code == 0) {
        this.teachingData = res.data.datas; // 获取授课数据
      }
    });
  },
  methods: {
    formatDate(date) {
      const year = date.getFullYear();
      const month = date.getMonth() + 1; // getMonth()返回的月份是从0开始的，所以需要+1
      const day = date.getDate();
      const hours = date.getHours();
      const minutes = date.getMinutes();
      const seconds = date.getSeconds();
      return `${year}-${month < 10 ? "0" + month : month}-${day < 10 ? "0" + day : day} ${hours}:${minutes < 10 ? "0" + minutes : minutes}:${seconds < 10 ? "0" + seconds : seconds}`;
    },
    getRecentSevenDays() {
      const today = new Date();
      const start = new Date(today.getTime() - 7 * 24 * 60 * 60 * 1000); // 7天前的时间
      const end = new Date(today.getTime()); // 今天的时间
      let startFormatted = this.formatDate(start);
      let endFormatted = this.formatDate(end);
      return { start: startFormatted, end: endFormatted };
    },
    // 返回按钮
    btnReturn() {
      this.$router.push({ name: "guidePage" });
    },
    // 选择日期
    selectDate() {
      // 调用课程次数统计数据接口
      let params = { category_id: this.$route.params.data?.id, begin: this.dateValue[0] + " 00:00:00", end: this.dateValue[1] + " 23:59:59" };
      statisticalDataOfCourseClassification(params).then((res) => {
        if (res.data.code == 0) {
          this.teachingData = res.data.datas; // 获取授课数据
        }
      });
    },
    // 修改课程信息
    modifyingInformation() {
      this.$router.push({ name: "createNewCategory", params: { data: this.courseClassificationData } });
    },
    // 确定按钮
    btnConfirm() {
      this.$router.push({ name: "guidePage" });
    },
  },
};
</script>

<style lang="scss" scoped>
.whole {
  width: 100vw;
  height: 100vh;
  background: #f4f4f4;
}

.main-content {
  position: absolute;
  top: 70px;
  width: 100vw;
  height: calc(100vh - 70px);
  padding: 20px 100px 0 100px;
  box-sizing: border-box;
}

.courseInformation {
  width: 850px;
  background: #ffffff;
  border-radius: 10px;
  padding: 20px 50px;
  box-sizing: border-box;
  box-shadow: 0 0 10px #cccccc;
}

.course-titleBlock {
  width: 12px;
  height: 26px;
  background: #3096fb;
}

.course-titleTxt {
  margin-left: 20px;
  font-size: 24px;

  font-weight: 400;
  color: #000000;
  line-height: 24px;
}

.courseInformation-coverBox {
  margin-top: 20px;
}

.courseInformation-txt {
  font-size: 22px;

  font-weight: 400;
  color: #555555;
  line-height: 22px;
}

.courseInformation-cover {
  margin-left: 25px;
  width: 270px;
  height: 135px;
}

.courseInformation-nameBox {
  margin-top: 20px;
  height: 50px;
}

.courseInformation-input {
  margin-left: 25px;
  width: 610px;
  height: 50px;
  border: 1px solid #757575;
  border-radius: 10px;
}

.publicInput {
  font-size: 20px;

  font-weight: 400;
  color: #555555;
  margin-left: 17px;
  width: 500px;
  height: 50px;
  border: 1px solid #757575;
  border-radius: 10px;
  background-color: transparent;
  border: 0px;
  outline: none;
}

/* 自定义placeholder的默认样式 */
input::-webkit-input-placeholder {
  color: #666666;
}

.basicData-contentBox {
  margin-top: 20px;
}

.basicData-content {
  width: 236px;
  height: 210px;
  background: #eaf4fd;
  border-radius: 10px;
  padding: 56px 0;
  box-sizing: border-box;
}

.basicData-txt {
  font-size: 20px;

  font-weight: 400;
  color: #555555;
}

.basicData-num {
  font-size: 60px;

  font-weight: 400;
  color: #3096fb;
  line-height: 60px;
}

.teachingData-contentBox {
  margin-top: 20px;
}

.teachingData-contentBox1 {
  margin-top: 10px;
}

.teachingData-content {
  width: 236px;
  height: 170px;
  background: #eaf4fd;
  border-radius: 10px;
  padding: 43px 0;
  box-sizing: border-box;
}

.barChart-box {
  width: 751px;
  height: 390px;
}

.btnPublicCss {
  width: 180px;
  height: 50px;
  background: #349afe;
  border-radius: 10px;
  font-size: 26px;

  font-weight: 400;
  color: #ffffff;
  line-height: 26px;
}

.btnBox {
  margin-top: 8px;
  width: 420px;
}

.cover-input {
  position: absolute;
  left: 0;
  top: 0;
  width: 270px;
  height: 135px;
  border-radius: 10px;
  opacity: 0;
  border: 0px;
  outline: none;
}

.courseClassificationData-cover {
  width: 361px;
  height: 210px;
  object-fit: cover;
  border-radius: 10px;
}

.courseInformation-box {
  margin-top: 34px;
}

.courseClassificationData-information {
  margin-left: 39px;
}

.premiumCourses-name {

  font-weight: 400;
  font-size: 22px;
  color: #000000;
}

.premiumCourses-message {
  margin-top: 18px;
}

.premiumCourses-founder {

  font-weight: 400;
  font-size: 16px;
  color: #484848;
}

.premiumCourses-line {
  margin-left: 5px;
  width: 1px;
  height: 15px;
  background: #484848;
}

.premiumCourses-system {
  margin-left: 5px;

  font-weight: 400;
  font-size: 16px;
  color: #484848;
}

.premiumCourses-teachingRecords {
  margin-top: 11px;

  font-weight: 400;
  font-size: 16px;
  color: #484848;
  opacity: 0.5;
}

.premiumCourses-divider {
  margin-top: 33px;
  width: 301px;
  height: 1px;
  background: #cbcabe;
}

.premiumCourses-affiliatedPlatform {
  margin-top: 11px;

  font-weight: 400;
  font-size: 16px;
  color: #484848;
  opacity: 0.5;
}

.modifyingInformation {
  margin-top: 20px;

  font-weight: 400;
  font-size: 20px;
  color: #349afe;
}
</style>
